export default {
  common: {
    language: "Language",
    logout: "Log out",
    yes: "Yes",
    no: "No"
  },
  languages: {
    uk: "Українська",
    ru: "Русский",
    en: "English"
  },
  notifications: {
    error: "Error",
    loginError: "Login error",
    restoreError: "Restore error",
    changePasswordError: "Password change error"
  },
  auth: {
    login: {
      title: "Sign in",
      subtitle: "Sign in to get access",
      passwordPlaceholder: "Password",
      submit: "Login",
      forgotPassword: "Forgot password?",
      noAccountTitle: "No account?",
      noAccountDesc: "Register now to get access to system features",
      register: "Register"
    },
    restore: {
      title: "Password recovery",
      subtitle: "Enter the email used for your account",
      emailNotFound: "This email does not exist in the system.",
      submit: "Restore",
      sentMessagePrefix: "A message was sent to",
      sentMessageSuffix: "with further instructions for restoring your password"
    },
    changePassword: {
      title: "Change password",
      oldPasswordPlaceholder: "Enter old password",
      newPasswordPlaceholder: "Create a new password",
      confirmPasswordPlaceholder: "Confirm new password",
      weakPassword:
        "Password is too weak. It must include at least one uppercase Latin letter, one digit and be at least 6 characters long.",
      passwordsMismatch: "Passwords do not match.",
      submit: "Change"
    }
  },
  register: {
    title: "Game registration",
    subtitle: "Please fill in all fields carefully",
    callsignLabel: "Callsign*",
    callsignPlaceholder: "Callsign",
    cyrillicHint: "Cyrillic letters only!",
    requiredField: "This field is required.",
    callsignMinLength: "Callsign must be at least {min} letters long.",
    callsignNotUnique: "This callsign is already taken.",
    passportPhotoLabel: "Passport photo*",
    uploadButton: "Upload",
    passportPhotoHint:
      "Please select and crop your photo carefully, because it will be used in your game passport.",
    legendLabel: "Character backstory*",
    legendPlaceholder: "Describe your character story",
    legendHint:
      "Applications without a backstory are not accepted. Maximum length is 1800 symbols.",
    legendMinLength: "Backstory must be at least {min} characters long.",
    legendMaxLength:
      "Backstory must be no more than {max} characters. Please shorten it a little.",
    contraindicationsLabel: "Contraindications",
    contraindicationsPlaceholder:
      "Specify your medical or other contraindications (if any)",
    photosLabel: "Several photos in equipment*",
    photosDragText: "Drag photos here",
    photosBrowseText: "or click here",
    photosPopupText: "upload image",
    photosDropText: "Drop here",
    photosHint:
      "Attach your OWN photos for dress-code approval. Each photo must be up to 1MB.",
    agreementTitle: "Agreement",
    agreementRulesPrefix: "I agree and undertake to follow the",
    agreementRulesLink: "rules",
    agreementRulesSuffix: "of the event",
    agreementData:
      "I voluntarily consent to storage, processing and use of my personal data provided by me",
    submit: "Register",
    imageTooBig: "Image size exceeds 1MB",
    errorTitle: "Registration error",
    email: {
      label: "E-mail*",
      placeholder: "Email",
      hint: "e.g. w.degtyarev@gmail.com",
      invalid: "Entered value is invalid.",
      invalidFormat: "Invalid email address format.",
      notUnique: "This email is already used.",
      tryLoginPrefix: "Try to",
      tryLoginAction: "sign in",
      tryLoginSuffix: "to the system."
    },
    fullName: {
      label: "Last name*, First name*, Middle name",
      lastNamePlaceholder: "Last name",
      firstNamePlaceholder: "First name",
      fatherNamePlaceholder: "Middle name",
      firstNameRequired: "First name is required.",
      firstNameMin: "First name must be at least {min} letters long.",
      lastNameRequired: "Last name is required.",
      lastNameMin: "Last name must be at least {min} letters long."
    },
    password: {
      label: "Password*",
      placeholder: "Create password",
      confirmPlaceholder: "Confirm password",
      weak:
        "Password is too weak. It must include at least one uppercase Latin letter, one digit and be at least 6 characters long.",
      mismatch: "Passwords do not match."
    },
    phone: {
      label: "Contact phone*",
      placeholder: "+38 (999) 999-9999",
      hint: "e.g. +38 (999) 999-9999"
    },
    birthday: {
      label: "Date of birth*",
      hint: "e.g. 26.04.1986"
    },
    city: {
      label: "City*",
      noOptions: "Start typing to search...",
      noResult: "Nothing found :( Keep trying",
      hint: "City you are coming from"
    },
    team: {
      label: "Team*",
      placeholder: "Enter your team name if it's not in the list",
      hint:
        "Specify your airsoft team or 'No command'. You can choose an existing one or enter a new one."
    },
    fractions: {
      label: "Faction*",
      placesLeft: "slots"
    },
    suit: {
      label: "Suit*",
      placeholder: "Select suit"
    },
    forbidden: {
      title: "Registration is closed",
      subtitle: "Thanks everyone, no slots left"
    },
    success: {
      title: "Thank you for your application!",
      textPrefix: "After review, an email will be sent to",
      textSuffix: "with further instructions",
      loginPrefix: "You can",
      loginLink: "Sign in to the system",
      loginSuffix: "using your provided credentials (email and password)"
    }
  },
  scan: {
    scanAnother: "Scan another",
    errorTitle: "Scan error"
  },
  components: {
    common: {
      none: "None",
      nothing: "Nothing",
      rub: "???."
    },
    grid: {
      actions: "Actions",
      action: "Action",
      total: "Total records"
    },
    memberData: {
      code: "Code",
      callsign: "Callsign",
      fraction: "Faction",
      suit: "Suit",
      legend: "Legend",
      rank: "Rank",
      experience: "Experience",
      money: "Money",
      createdAt: "Created",
      passportPhoto: "Passport photo",
      lookPhoto: "Access photo",
      profilePhotos: "Profile photos",
      passport: "Passport",
      passportFront: "front side",
      passportBack: "back side",
      passportQr: "QR code",
      generatePassport: "Generate passport",
      regeneratePassport: "Regenerate passport",
      legendTitle: "Stalker legend {callsign}",
      fractionTitle: "Faction description {title}",
      suitTitle: "Suit description {title}"
    },
    memberRequest: {
      closed: "Registration for {title} is closed",
      hasPassport: "Game passport availability",
      passportYes: "Available",
      passportLost: "Lost"
    },
    regPending: {
      pending: "Pending issue"
    },
    userData: {
      fullName: "Full name",
      phone: "Phone",
      bornAt: "Date of birth",
      city: "City",
      team: "Team",
      contraindications: "Contraindications"
    },
    notifications: {
      whatChanged: "What changed",
      legendDiffTitle: "Legend changes details",
      before: "Before",
      after: "After"
    },
    gpsAdd: {
      hint: "Here you can set your current GPS position as object coordinates",
      unavailable: "Geolocation unavailable",
      addMark: "Add mark"
    }
  },
  member: {
    character: {
      back: "Back",
      createLimitNote: "Please note: maximum number of your characters is 3.",
      createActiveNote:
        "A new character will become active for event applications. Choose wisely.",
      passportPhotoLabelEdit: "Passport photo",
      uploadNew: "Upload new",
      passportLocked:
        "Editing passport photo is unavailable because you already have a passport.",
      suitLabelEdit: "Suit",
      suitLocked:
        "Suit change is unavailable because you already have a confirmed request for the nearest event.",
      legendLabelEdit: "Character backstory",
      legendLocked:
        "Backstory change is unavailable because you already have a confirmed request for the nearest event.",
      photosLabelEdit: "Several photos in equipment",
      photosLocked:
        "Changing approval photos is unavailable because you already have a confirmed request for the nearest event.",
      saveChanges: "Save changes",
      saved: "Data saved"
    },
    profile: {
      addCharacter: "Add character",
      createBlocked:
        "Creating a new character is unavailable because you already have a confirmed request for the nearest event"
    },
    members: {
      callsign: "Callsign:",
      suit: "Suit:",
      rank: "Rank:"
    },
    events: {
      noActive: "No available events yet",
      dates: "Event dates",
      feeBefore: "Fee before {date}",
      yourFeeBefore: "Your fee before {date}",
      feeAfter: "Fee after {date}",
      yourFeeAfter: "Your fee after {date}",
      feeAfterReg: "Fee after {date}",
      yourFeeAfterReg: "Your fee after {date}",
      regClosing: "registration closes",
      history: "Story",
      participants: "Participants",
      showParticipants: "Show {count} participants",
      requests: "Requests",
      requestStatus: "Request status:",
      organizerComment: "Organizer comment",
      submitRequest: "Submit request",
      fractionFull: "Unfortunately, your faction is already full",
      historyTitle: "Event story: {title}",
      requestTitle: "Request for event: {title}"
    }
  },
  admin: {
    edit: {
      back: "Back",
      save: "Save"
    },
    common: {
      refresh: "Refresh",
      userDataTitle: "User data",
      memberDataTitle: "Member data"
    },
    members: {
      income: "Income",
      cols: {
        city: "City",
        callsign: "Callsign",
        lastName: "Last name",
        firstName: "First name",
        fraction: "Faction",
        paid: "Paid",
        paymentType: "Payment type",
        requestDate: "Request date"
      }
    },
    registration: {
      pendingDataTitle: "Issue data",
      cols: {
        suit: "Suit",
        rank: "Rank",
        experience: "Experience",
        money: "Money",
        pending: "Pending issue"
      },
      moneyValue: "{value} ???.",
      pendingCount: "{count} item(s)",
      pendingEmpty: "Nothing"
    },
    notifications: {
      newCount: "New notifications: {count}",
      view: "View",
      changeTitle: "View change",
      processSuccess: "Change marked as read",
      cols: {
        type: "Change type",
        readBy: "Read by",
        updatedAt: "Change date"
      }
    },
    requests: {
      organizerCommentTitle: "Organizer comment",
      confirmModalTitle: "Request approval from {who}",
      commentModalTitle: "Comment for request from {who}",
      rejectModalTitle: "Request rejection from {who}",
      payModalTitle: "Registration payment from {who}",
      feeDiscount: "Fee with temporary discount",
      feeNoDiscount: "Fee without temporary discount",
      feeAfterClose: "Fee after registration close",
      addComment: "Add comment",
      comment: "Comment",
      confirmCommentPlaceholder: "Add comment to the approval email (optional)",
      commentPlaceholder: "Add comment to the email",
      howMuchPaid: "How much was paid?",
      paidDescription: "(total amount, if paid in parts)",
      notPaid: "not paid",
      paymentType: "Payment type",
      forceFullDescription:
        "(enable when you need to mark full payment even if the full sum was not paid)",
      forceFullPayment: "Force full payment",
      free: "free",
      currency: "UAH",
      descToDate: "* how much player should pay before {date}",
      descAfterDate: "* how much player should pay after {date}",
      descAfterReg:
        "* how much player should pay after {date} (registration close)",
      cols: {
        passport: "Passport?",
        fee: "Fee",
        discountFee: "With discount",
        updated: "Updated",
        legendOk: "Legend OK?",
        lookOk: '"Look" OK?',
        status: "Status"
      },
      actions: {
        lookApprove: "Approve look",
        legendApprove: "Approve legend",
        approve: "Approve",
        comment: "Comment",
        reject: "Reject",
        payed: "Paid"
      }
    },
    firmwareAdd: {
      nameLabel: "Firmware name",
      fileLabel: "Firmware binary file",
      typeLabel: "Firmware type",
      descLabel: "Description",
      descPlaceholder: "Add firmware description (optional)",
      tagLabel: "Tag",
      currentLabel: "Current?",
      currentDesc: "This firmware will become current",
      add: "Add",
      savedTitle: "Firmware added",
      savedBody: 'Firmware version "{title}" (ID = {id}):'
    },
    firmwaresList: {
      add: "Add",
      cols: {
        type: "Type",
        tag: "Tag",
        version: "Version",
        current: "Current?",
        file: "File",
        createdAt: "Created at"
      }
    },
    itemsList: {
      add: "Add",
      noCode: "none",
      cols: {
        code: "Code",
        title: "Title",
        type: "Item type",
        owner: "Item owner",
        place: "Base location",
        createdAt: "Created at"
      },
      actions: {
        edit: "Edit"
      }
    },
    charactersList: {
      add: "Add",
      noCode: "none",
      cols: {
        code: "Code",
        title: "Title",
        type: "Item type",
        owner: "Item owner",
        location: "Base location",
        createdAt: "Created at"
      },
      actions: {
        edit: "Edit"
      }
    },
    locationsList: {
      add: "Add",
      cols: {
        title: "Title",
        type: "Location type",
        createdAt: "Created at"
      },
      actions: {
        edit: "Edit"
      }
    },
    itemEdit: {
      nameLabel: "Item name",
      photoLabel: "Photo",
      descLabel: "Description",
      descPlaceholder: "Add item description (optional)",
      typeLabel: "Item type",
      placeLabel: "Base location",
      locationBindLabel: "Bind to location",
      locationPlaceholder: "Enter location",
      locationNotFound: "Location not found",
      ownerLabel: "Owner",
      activeLabel: "Active?",
      activeDesc: "You can deactivate an item so it is hidden everywhere",
      virtualLabel: "Virtual?",
      virtualDesc: '"Virtual" items are used for price lists, e.g. medkits',
      gpsLabel: "Position",
      addLocation: "Add location",
      addComment: "Add comment",
      commentLabel: "Comment",
      commentPlaceholder: "Add comment for item (optional)",
      gpsModalTitle: "Add GPS marker",
      savedTitle: "Item saved",
      savedCode: 'Code for item "{title}" (ID = {id}):'
    },
    locationEdit: {
      nameLabel: "Location name",
      photoLabel: "Photo {index}",
      descLabel: "Description",
      descPlaceholder: "Add location description (optional)",
      typeLabel: "Location type",
      zoneLabel: "Zone",
      gpsLabel: "Position",
      addLocation: "Add location",
      activeLabel: "Active?",
      activeDesc: "You can deactivate a location so it is hidden everywhere",
      gpsModalTitle: "Add GPS marker",
      savedTitle: "Location saved",
      savedBody: 'Location "{title}" (ID = {id}) saved successfully'
    },
    characterEdit: {
      nameLabel: "Character name",
      photoLabel: "Photo",
      descLabel: "Description",
      descPlaceholder: "Add character description (optional)",
      addComment: "Add comment",
      commentLabel: "Comment",
      commentPlaceholder: "Add comment for character (optional)",
      savedTitle: "Character saved",
      savedCode: 'Code for character "{title}" (ID = {id}):'
    }
  },
  enums: {
    common: {
      noCommand: "No command"
    },
    rank: {
      novice: "Novice",
      experienced: "Experienced",
      veteran: "Veteran",
      master: "Master",
      legend: "Legend"
    },
    pda: {
      own: "Own",
      rent: "Rent",
      purchase: "Purchase",
      none: "None"
    },
    shotLight: {
      own: "Own",
      purchase: "Purchase",
      none: "None"
    },
    request: {
      approved: "Approved",
      commented: "Commented",
      declined: "Declined",
      partially_paid: "Partially paid",
      paid: "Paid",
      none: "Pending"
    },
    paymentType: {
      cashless: "Cashless",
      cash: "Cash",
      combatant: "Combatant",
      free: "Free",
      none: "Not paid"
    },
    itemType: {
      suit: "Suit",
      artefact: "Artefact",
      quest: "Quest",
      other: "Other"
    },
    itemOwner: {
      own: "Club",
      personal: "Personal",
      other: "Other"
    },
    itemPlace: {
      storage: "Storage",
      garage: "Garage",
      home: "Home",
      other: "Other"
    },
    firmwareType: {
      unknown: "Unknown",
      artefact: "Artefact",
      soul: 'PDA "Soul"',
      anomaly: "Anomaly",
      defence: "Defence"
    },
    locationType: {
      main: "Main",
      quest: "Quest",
      other: "Other"
    },
    locationZone: {
      red: "Red",
      yellow: "Yellow",
      green: "Green",
      blue: "Blue"
    },
    actionType: {
      unknown: "Unknown",
      legend: "Legend",
      legend_master: "GM Legend",
      passport_photo: "Passport photo",
      photos: "Photos",
      callsign: "Callsign",
      suit: "Suit",
      fraction: "Faction",
      new_request: "New request"
    },
    actionMessage: {
      unknown: "Unknown",
      legend: "Legend changed",
      legend_master: "GM Legend",
      passport_photo: "Passport photo changed",
      photos: "Photos changed",
      callsign: "Callsign changed",
      suit: "Suit changed",
      fraction: "Faction changed",
      new_request: "New request created"
    }
  },
  nav: {
    profile: "Profile",
    events: "Events",
    requests: "Requests",
    members: "Members",
    registration: "Registration",
    notifications: "Notifications",
    messages: "Messages",
    staff: "Staff",
    items: "Items",
    firmwares: "Firmwares",
    locations: "Locations",
    quests: "Quests"
  },
  routes: {
    Dashboard: "Dashboard",
    Profile: "Profile",
    ProfileEdit: "Edit profile",
    ProfileCreate: "Create character",
    Events: "Events",
    EventMembers: "Participants",
    AdminRequests: "Requests",
    AdminMembers: "Members",
    AdminRegistration: "Registration",
    AdminStaff: "Staff",
    AdminNotifications: "Notifications",
    AdminMessages: "Messages",
    AdminItems: "Items",
    AdminItemEdit: "Edit item",
    AdminFirmwares: "Firmwares",
    AdminFirmwareAdd: "Add firmware",
    AdminLocations: "Locations",
    AdminLocationEdit: "Edit location",
    AdminQuests: "Quests",
    Scan: "Scan",
    Register: "Registration",
    Login: "Login",
    Restore: "Restore password",
    PassChange: "Change password"
  },
  errors: {
    api: {
      ERR_SERVICE: "Service error",
      ERR_NOT_FOUND: "Not found",
      ERR_ALREADY_EXISTS: "Record already exists",
      ERR_ALREADY_ENABLED: "Already enabled",
      ERR_ALREADY_DISABLED: "Already disabled",
      ERR_BAD_REQUEST: "Invalid request",
      ERR_BAD_PARAM: "Invalid parameter",
      ERR_NOT_ALLOWED: "Action is not allowed",
      ERR_BAD_JWT: "Invalid JWT token",
      ERR_BALANCE_NOT_ENOUGH: "Insufficient balance",
      ERR_BAD_AUTH: "Authorization error",
      ERR_BAD_SIGNATURE: "Invalid signature"
    },
    bad_param: {
      password: {
        invalid_restore_token: "Invalid password restore token",
        invalid_current_password: "Current password is invalid"
      }
    },
    not_allowed: {
      request: {
        invalid_check_state: "Action is not allowed in the current request check state"
      },
      member: {
        other_member_editing: "Editing another member is not allowed",
        confirmed_request_edit: "Editing a confirmed request is not allowed",
        max_user_members_reached: "Maximum number of user characters reached"
      }
    },
    fraction_full: {
      request: {
        members_limit_reached: "Faction member limit for this event has been reached",
        requests_limit_reached: "Faction request limit for this event has been reached"
      }
    },
    service: {
      mail: {
        create_commented_email: "Failed to create commented request email",
        create_declined_email: "Failed to create declined request email"
      }
    }
  }
};
